import React from 'react'
import axios from 'axios'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import Loader from 'Pods/Shared/Loader'

import ItemsListingWrapper from 'Pods/ItemsListing/ItemsListingWrapper'
import TrendingModelsTooltip from './TrendingModelsTooltip'

class TrendingModels extends React.Component {
  constructor() {
    super()

    this.state = {
      data: null,
      axiosSource: axios.CancelToken.source(),
    }

    this.fetchData = this.fetchData.bind(this)
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    return axios.get('/api/internal/seller_dashboard/trending_items', {
      cancelToken: this.state.axiosSource.token,
    })
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    return this.setState({
      data: response.data.data,
    })
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 col-xl-10 offset-xl-1">
          <div className="card card--flat dashboard-card--trending">
            <div className="dashboard-card">
              <h3>
                <a href="/top-3d-models">Trending Models</a> <Tooltip
                  tooltipClassName="tooltip--trending-models-tooltip"
                  className="tooltip--trending-models-info"
                  id="dashboard__trending-models-info"
                  delayHide={300}
                  content={<TrendingModelsTooltip />}
                >
                  <Icon type={['far', 'question-circle']} color="grey" notSpaced />
                </Tooltip>
              </h3>
              {!this.state.data ? (
                <Loader />
              ) : (
                this.state.data.length === 0 ? (
                  <div className="empty-content u-text-center">
                    <p>
                      Ooops! Something went wrong
                    </p>
                  </div>
                ) : (
                  <ItemsListingWrapper perRowType="trending" gaList="Trending Models" data={this.state.data} isWithCarousel />
                ))}
            </div>
          </div>

          <div className="card card--flat">
            <a href="/top-3d-models" className="btn btn-transparent btn-block btn-show-more">Show more</a>
          </div>
        </div>
      </div>
    )
  }
}

export default TrendingModels
